import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DtoClientAdmin, ClientAccountDetails, Pagination } from '../../models/mat-account.model';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SwapPackageComponent } from './swap-package/swap-package.component';
import { MatDialogCloseEvent, Mode } from '../../const';
import { CommentDialogComponent } from '../../shared/components/comment-dialog/comment-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';

export enum Tabs { MatAccount = "MatAccount", IndividualSchool = "IndividualSchool" } 

@Component({
  selector: 'app-user-center',
  templateUrl: './user-center.component.html',
})
export class UserCenterComponent implements OnInit {
  @Input() matAccountDetails: any;
  @Input() matAdminDetails: DtoClientAdmin[] = [];
  @Input() matAccountDetailData!: string;
  @ViewChild('matAccountDetail') matAccountDetail!: ElementRef;
  @Output() refreshData = new EventEmitter<Pagination>();
  @Output() actionTriggered = new EventEmitter<any>();
  @Input() totalRecords: number = 0;
  
  mode = Mode;
  searchTerm: string = "";
  pageSize:number = 10;
  pageNumber:number = 0;
  pageOffSet:number = 0;
  sortColumn: string = "";
  sortDirection: string = "";
  sortMatAccountNameAsc: boolean = true;
  sortAccountAdminNameAsc: boolean = true;
  sortPackageNameAsc: boolean = true;
  activeTab: string = Tabs.MatAccount;
  tabs = Tabs;
  sectorId: number = 0;
  
  constructor(private dialog: MatDialog, private route: Router, private toasterService: ToastrService) {}

  ngOnInit(): void {
    this.sectorId = Number(sessionStorage.getItem('sector'));  
  }

  ngAfterViewInit() {
    this.applyTruncateClass();
  }

  applyTruncateClass() {
    const element = this.matAccountDetail?.nativeElement!;
    if (element && element.scrollWidth > 200) { 
      element.classList.add('truncate');
    }
  }

  gotoAdminDetails(clientAccountId: number, clientAccountName: string, packageId: number) {
    this.route.navigate(['/adminDetails'], { queryParams: { clientAccountId: clientAccountId, clientAccountName: clientAccountName, packageId: packageId } });
  }

  changeTab(tabName: string){
    this.activeTab = tabName;
    this.getGridData();
  }
  
  changePage(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageNumber = event.pageIndex;
    this.pageOffSet = this.pageNumber * this.pageSize;
    this.getGridData();
  }
  
  getGridData(sortColumn = "", sortDirection = ""){
    if(sortColumn){
      this.sortColumn = sortColumn;
      this.sortDirection = sortDirection;
    }
    let payload: any = {};
      payload.sortColumn = this.sortColumn.charAt(0).toUpperCase() + this.sortColumn.slice(1);
      payload.sortDirection = this.sortDirection;
      payload.pageOffset = this.pageOffSet;
      payload.pageSize = this.pageSize;
      payload.searchTerm = this.searchTerm ? this.searchTerm.trim() : "";
      this.refreshData.emit(payload);
  }

  actionClicked(data: ClientAccountDetails, event: string){

    sessionStorage.setItem('client_reference', data.clientReference!.toString());
    sessionStorage.setItem('client_account', data.clientAccountId!.toString());
    sessionStorage.setItem('package_of_client_account', data.clientAccountId!.toString());
    sessionStorage.removeItem('my_ref_school_id');
    sessionStorage.removeItem('school_id');

    if(!data.document.length && event == Mode.Preview){
      this.toasterService.warning("No attachment found");
      return;
    }
    data.action = event;
    this.actionTriggered.emit(data);
  }

  openSwapChangeModal(event: any, matAccountDetail: ClientAccountDetails): void {
    if (!event || !event.target) {
      return;
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'swapDropdown';
    dialogConfig.width = '800px';
    dialogConfig.data = matAccountDetail;
    this.dialog
      .open(SwapPackageComponent, dialogConfig)
      .afterClosed()
      .subscribe((popupEvent: any) => {
        if (popupEvent?.event == MatDialogCloseEvent.SUCCESS) {
          this.getGridData();
        }
      });
  }
  openCommentModal(comment: string) {
    this.dialog.open(CommentDialogComponent, {
      width: '500px',
      data: comment
    });
  }
}